import { createContext, type RefObject, use, useRef } from 'react'

const CacheSharePasswordContext = createContext<RefObject<Map<string, string>>>(null as never)

type Props = {
  children: React.ReactNode
}
export const CacheSharePasswordProvider: React.FC<Props> = ({children}) => {
  const pass_map = useRef(new Map<string, string>())
  return <CacheSharePasswordContext value={pass_map}>
    {children}
  </CacheSharePasswordContext>
}

export const useGetCacheSharePassword = (share_id: string) => {
  const map = use(CacheSharePasswordContext).current
  return map.get.bind(map, share_id)
}

export const useSetCacheSharePassword = (share_id: string) => {
  const map = use(CacheSharePasswordContext).current
  return map.set.bind(map, share_id)
}

export const useClearCacheSharePassword = () => {
  const map = use(CacheSharePasswordContext).current
  return map.clear.bind(map)
}
